export const browserImageReader = (file) => {
    return new Promise(
        (resolve, reject) => {
            const reader = new FileReader();
            reader.addEventListener("load", () => resolve(reader.result), false);
            //read file as base64 string
            reader.readAsDataURL(file);
        }
    );
}